export default defineNuxtRouteMiddleware( async (to, from) => {
    const {objectTypes} = await useObjectTypes();
    const query = useState('value-parameters-queries')

    if (objectTypes.value.length == 0) {
        abortNavigation()
    }

    if (to.query.type == undefined && !('all' in to.query)) {
        if (query.value) {
            return navigateTo({
                path: to.path,
                query: {...query.value}
            })
        } else {
            return navigateTo({
                path: to.path,
                query: {
                    type: objectTypes.value[0].id
                }
            })
        }
    }

    query.value = to.query
})
